import { useEffect } from "react";

/**
 * Fired callback function if clik is deteted outside of ref elements
 * @param refs
 * @param callback
 */
export const useOutsideDetector = (
  refs: Array<React.RefObject<HTMLElement>>,
  callback: () => void
): void => {
  const handleClickOutside = (event: MouseEvent): void => {
    const isOutside = (ref: React.RefObject<HTMLElement>): boolean | null =>
      ref.current && !ref.current.contains(event.target as HTMLElement);

    if (refs.every(isOutside)) {
      callback?.();
    }
  };

  useEffect(() => {
    // Bind the event listener, use mouseup instead of click cause we need to catch event before click
    document.addEventListener("mouseup", handleClickOutside);

    return (): void => {
      // Unbind the event listener on clean up
      document.removeEventListener("mouseup", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
